import * as PropTypes from 'prop-types'
import type { MuiTheme } from 'material-ui/styles'
import { NonThrowingComponent } from '../../../app-core/lib/ui/NonThrowingComponent'
import { Util_shallowEqual } from '../Util/Util.shallowEqual'

export interface Base_IComponentContext<Data, Operations> {
    readonly data: Data
    dataSubscribe: (fn: () => void) => void
    dataUnsubscribe: (fn: () => void) => void
    readonly operations: Operations
    readonly muiTheme: MuiTheme
}

export abstract class Base_Component<P = {}, S = {}> extends NonThrowingComponent<P, S> {
    public static contextTypes = {
        data: PropTypes.object,
        dataSubscribe: PropTypes.func,
        dataUnsubscribe: PropTypes.func,
        operations: PropTypes.object,
        muiTheme: PropTypes.object,
    }
    public data: any
    public operations: any
    public context: Base_IComponentContext<any, any>

    constructor(props: P, context: Base_IComponentContext<any, any>) {
        super(props, context)
        this.data = context.data
        this.operations = context.operations
    }

    protected async setStateAsync<K extends keyof S>(state: Pick<S, K>) {
        return new Promise<void>((resolve) => this.setState(state, resolve))
    }
}

export abstract class Base_PureComponent<P, S> extends Base_Component<P, S> {
    public shouldComponentUpdate(newProps: P, newState: S) {
        // https://github.com/facebook/react/blob/master/packages/react-reconciler/src/ReactFiberClassComponent.js#L193
        return !Util_shallowEqual(this.props, newProps) || !Util_shallowEqual(this.state, newState)
    }
}
